import { useQuery } from "@tanstack/react-query";
import fetchData from "../fetcher";
import { SessionResponse } from "./types";

export const useSession = (uid?: string, isEnabled = true) => {
    return useQuery({
        queryKey: ["session", uid],
        queryFn: () => fetchData<SessionResponse>(`/iam/v4/security/sessions?uid=${uid}`),
        enabled: isEnabled && !!uid,
    });
};
